import { StyleSheet } from 'react-native';

import { mediaQueryValues } from '../../media-query';
import { extraSmallPaddingBox } from '../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
  },
  activityView: {
    flex: 1,
  },
  progressBar: {
    flex: 1,
    marginRight: mediaQuery.small,
  },
  progressHeaderContainer: {
    paddingVertical: 0,
  },
  progressHeader: {
    alignItems: 'center',
    maxWidth: 1140,
    width: '100%',
  },
  headerSection: {
    flex: 1,
    height: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ...extraSmallPaddingBox,
  },
  navSection: {
    paddingVertical: 0,
    justifyContent: 'space-around',
  },
  borderHeaderSection: {
    borderRightWidth: 1,
    borderLeftWidth: 1,
  },
  centerHeaderSection: {
    flex: 2,
  },
  breadcrumbText: {
    fontSize: 14,
  },
});
